<template>
  <section class="other_options">
    <h2>{{ $_translations.value.page_profile_edit_section_other_settings_title }}</h2>

    <SettingsButtonItem :text="subscriptionText" @click="handleSubscriptionClick" />

    <SettingsButtonItem
      v-if="hasInviteFunctionality"
      text="page_profile_edit_settings_item_invite"
      @click="openInviteModal"
    />
  </section>

  <BaseResubscribe v-if="isResubscribeVisible" @resubscribe:resolved="handleResubscribeResolved" />

  <BaseUnsubscribe v-if="isUnsubscribeVisible" @unsubscribe:resolved="handleUnsubscribeResolved" />

  <InviteModal v-if="isInviteModalOpen" @invite:resolved="closeInviteModal" />
</template>

<script setup>
import { computed, ref } from 'vue';
import BaseResubscribe from '@/components/subscription/BaseResubscribe.vue';
import BaseUnsubscribe from '@/components/subscription/BaseUnsubscribe.vue';
import InviteModal from '@/components/modal/InviteModal.vue';
import SettingsButtonItem from '@/views/profileEdit/components/item/SettingsButtonItem.vue';
import useAppSettingsStore from '@/store/modules/appSettings.js';
import useAuthStore from '@/store/modules/auth.js';
import useModalHook from '@/hooks/useModal.js';

const appSettingsStore = useAppSettingsStore();
const authStore = useAuthStore();

const hasInviteFunctionality = appSettingsStore.appProperties.inviteConfig.inviteEnabled;

const [isInviteModalOpen, openInviteModal, closeInviteModal] = useModalHook();

const isResubscribeVisible = ref(false);
const isUnsubscribeVisible = ref(false);

const subscriptionText = computed(() => authStore.user.subscribed
  ? 'page_profile_edit_settings_item_unsubscribe'
  : 'page_profile_edit_settings_item_resubscribe',
);

const handleSubscriptionClick = () => {
  if (authStore.user.subscribed) {
    isUnsubscribeVisible.value = true;
  } else {
    isResubscribeVisible.value = true;
  }
};

const handleResubscribeResolved = () => {
  isResubscribeVisible.value = false;
};

const handleUnsubscribeResolved = () => {
  isUnsubscribeVisible.value = false;
};
</script>
